import Dialog from '@mui/material/Dialog'
import DialogBody from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import Modal from '../Modal/Modal'
import { useContext } from 'react'
import SettingContext from '../../services/context/setting-contentxt/setting-context'
interface iProps{open:boolean,setOpen:Function,children:any,title:string}

export default function MyDialog ({open,setOpen,children,title}:iProps) {
    const {isPc}=useContext(SettingContext)

    return (
        <Modal open={open} toggle={()=>setOpen(false)}
        >
            <DialogTitle position={'relative'} >
               
                <div style={{fontSize:isPc?'1.4rem':'1rem',fontWeight:'bold'}} 
                className=' primary-font-color'>

                {title}
                </div>
            </DialogTitle>
            <DialogBody >

                {children}
            </DialogBody>
            <DialogActions>
                
            </DialogActions>
        </Modal>
    )
}